"use strict";

exports.__esModule = true;
exports.SEARCH_WIDTH_WITH_CATEGORY_MENU = void 0;
var SEARCH_WIDTH_WITH_CATEGORY_MENU = exports.SEARCH_WIDTH_WITH_CATEGORY_MENU = '25.6rem';